import React, { Fragment } from 'react';
import Accordion from '@boschebike/ebds-react/dist-esm/components/Accordion.js';
import Container from '@boschebike/ebds-react/dist-esm/components/Container.js';
/**
 * @typedef {import('../../App.d.ts').AccordionProps} AccordionProps
 */

/**
 *
 * @param {AccordionProps} props
 * @returns {React.js.Element|null}
 * @constructor
 */
const AccordionHeadline = (props) => {
  if (!props.headline) {
    return null;
  }

  if (props.isGroupItem) {
    return <h3>{props.headline}</h3>;
  }

  return <h2>{props.headline}</h2>;
};

const AccordionContainer = (props) => {
  return <Container data-testid="accordion-wrapper">{props.children}</Container>;
};

/**
 *
 * @param {AccordionProps} props
 * @returns {Element}
 * @constructor
 */
export default (props) => {
  const Wrapper = props.isGroupItem ? Fragment : AccordionContainer;
  return (
    <Wrapper>
      <AccordionHeadline
        data-testid="accordion-headline"
        headline={props.headline}
        isGroupItem={props.isGroupItem}
      />
      <Accordion data-testid="accordion">{props.children}</Accordion>
    </Wrapper>
  );
};
